module.exports = __webpack_public_path__ + "static/media/Muli-Bold.44ea8275.ttf";